import { withInstall } from '@lit-element/utils'
import Renderer from './src/renderer'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtRenderer: SFCWithInstall<typeof Renderer> = withInstall(Renderer)

export default LtRenderer

export * from './src/renderer'
